<template>
  <el-dialog
     :title="this.$t('member_become_a_member')"
     width="500px" center class="custom-dialog-title"
     :visible.sync="showDialog"
     @close="handleClose">
    <div class="dialog-content-container">
      <!-- 左侧共用图片 -->
      <div class="shared-icon-container">
        <img src="@/assets/member/hyd.png"  alt="icon">
      </div>
      <!-- 右侧内容区域 -->
      <div class="content-area">
        <div class="logout-dialog-title">
          <span>{{this.$t('member_to_become_a_member_tip')}}</span>
        </div>
        <div class="radio-group-container">
        <el-radio-group v-model="formData.choice">
          <el-radio :label="true">{{this.$t('member_yes')}}</el-radio>
          <el-radio :label="false">{{this.$t('member_no')}}</el-radio>
        </el-radio-group>
        </div>
      </div>
    </div>
    <div style="padding-left: 30px;padding-right: 30px;">
      <div v-if="formData.choice === false" class="reason-section">
        <div class="reason-input-container">
          <span class="reason-label">{{this.$t('member_reason')}}:</span>
          <el-input
            type="textarea"
            :rows="2"
            v-model="formData.reason"
            :placeholder="this.$t('member_need_reason')"
            @keyup.enter="confirmCancel"
            ref="cancelReasonInput"
            class="reason-textarea"
          ></el-input>
        </div>
        <div class="logout-dialog-buttons">
<!--          <button class="dialog-btn cancel-btn" @click="showDialog = false">-->
<!--            {{this.$t("layout_cancel")}}-->
<!--          </button>-->
          <button class="dialog-btn confirm-btn" @click="confirmCancel()">
            {{this.$t("layout_confirm")}}
          </button>
        </div>
      </div>
      <div v-else class="logout-dialog-buttons">
      </div>
    </div>
  </el-dialog>
</template>

<script>
import * as cache from '@/utils/cache';
import * as auth from "@/api/platform/auth";
export default {
  name: "TcodePreMember",
  components: {},
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      formData: {
        pk_user: cache.getUserInfo().pk,
        reason: "",
        choice: null // 用于存储单选按钮的选择
      },
      //showDialog: false,
    }
  },
  watch: {
    // 监听 choice 变化，仅当选择 Yes 时跳转
    "formData.choice"(newVal) {
      if (newVal === true) {
        this.showDialog = false; // 关闭弹窗
        this.$router.push("/becomeMember"); // 跳转到购买页
      }
    },
  },
  methods: {
    confirmCancel: function () {
      if (this.formData.reason.trim() === '') {
        this.$message({type: "error", message: this.$t('member_need_reason')});
        return;
      }
      this.processChoice();
    },

    processChoice: function() {
      const requestData = {
        pk: this.formData.pk_user,
        choice: this.formData.choice,
        reason: this.formData.choice ? '' : this.formData.reason
      };

      auth.updateUserReason(requestData).then(resp => {
        this.showDialog = false;
      }).catch(error => {
      });
    },

    handleClose() {
      // 关键修改3：关闭时通知父组件
      this.$emit('update:showDialog', false);
    },
  },
  mounted() {

  },
  created: function () {

  }
}
</script>

<style>
/* 新增的共用图片样式 */
.dialog-content-container {
  display: flex;
  padding-left: 25px;
}

.shared-icon-container {
  margin-top: -25px;

}

.shared-dialog-icon {
  width: 24px;
  height: auto;
  margin-top: 3px; /* 与第一行文字对齐 */
}

.content-area {
  flex: 1;
  margin-left: -85px;
}

.radio-group-container {
  display: flex;
  justify-content: flex-start;
  padding: 0;
  justify-content: center;
  margin: 15px 0;
}
/* 添加这部分样式来覆盖默认的标题样式 */
.custom-dialog-title .el-dialog__header {
  text-align: left;
  padding-left: 35px;
  height: 40px; /* 设置固定高度 */
  display: flex;
  align-items: center; /* 垂直居中 */
}
.custom-dialog-title .el-dialog__title {
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 600;
}
.reason-input-container {
  display: flex;
  align-items: flex-start;
  margin: 20px 0;
  padding-left: 20px;
  padding-right: 20px;
}

.reason-label {
  width: 60px;
  padding-top: 8px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 400;
}

.reason-textarea {
  flex: 1;
  margin-left: 10px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  font-weight: 400;
}

.reason-section {
  transition: all 0.3s ease;
}

.logout-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.logout-dialog-title {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  font-family: Segoe UI;
  font-size: 15px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 400;
}

.logout-dialog-buttons {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-top: 30px;
  margin-bottom: 20px;
}

.dialog-btn {
  padding: 8px 35px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.cancel-btn {
  background-color: #F4F3F1;
  color: #AA81FF;
  border: 1px solid #AA81FF;
}

.cancel-btn:hover {
  background-color: #e0e0e0;
}

.confirm-btn {
  background-color: #AA81FF;
  color: white;
  border: none;
}

.confirm-btn:hover {
  background-color: #7200D6;
}
</style>



// WEBPACK FOOTER //
// src/pages/tcode/member/preMember.vue